import type { TransformState } from 'features/knowledgeDocumentViewer/components/viewer/shared/types'
import { useSyncExternalStore } from 'react'

export interface TransformStore {
  get: () => TransformState
  set: (state: TransformState) => void
  subscribe: (listener: () => void) => () => void
}

export function createTransformStore(initial: TransformState): TransformStore {
  let current = initial
  const listeners = new Set<() => void>()
  return {
    get: () => current,
    set: (state) => {
      current = state
      listeners.forEach((listener) => listener())
    },
    subscribe: (listener) => {
      listeners.add(listener)
      return () => {
        listeners.delete(listener)
      }
    },
  }
}

export function useTransformStoreState(store: TransformStore): TransformState {
  return useSyncExternalStore(store.subscribe, store.get)
}
